import { ShieldCheck, Database, Clock, UserCheck, Cookie, Mail } from "lucide-react";
import { SEO } from "@/components/SEO";

export default function PolitiqueConfidentialitePage() {
  return (
    <div className="min-h-screen bg-white" data-testid="politique-confidentialite-page">
      <SEO
        title="Politique de Confidentialité - Mediastore Niort"
        description="Politique de confidentialité et protection des données personnelles (RGPD) du site mediastore79.com. Mediastore Niort, réparation iPhone, Mac et ordinateurs."
        path="/politique-de-confidentialite"
        breadcrumbs={[
          { name: "Accueil", path: "/" },
          { name: "Politique de Confidentialité", path: "/politique-de-confidentialite" },
        ]}
      />

      <section className="py-16 md:py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full mb-6">
              <ShieldCheck className="h-5 w-5" />
              <span className="font-semibold">Protection des données — RGPD</span>
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">Politique de Confidentialité</h1>
            <p className="text-slate-600">
              Mediastore s&apos;engage à protéger vos données personnelles conformément au Règlement
              Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.
            </p>
          </div>
        </div>
      </section>

      <section className="pb-20">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto space-y-10">

            <div data-testid="confidentialite-donnees">
              <h2 className="text-base md:text-lg font-bold text-slate-900 flex items-center gap-2 mb-3">
                <Database className="h-5 w-5 text-red-600" />
                1. Données collectées
              </h2>
              <p className="text-sm text-slate-700 leading-relaxed mb-3">
                Nous collectons uniquement les données nécessaires au traitement de vos demandes,
                via les formulaires du site :
              </p>
              <ul className="space-y-2 text-sm text-slate-700">
                <li className="flex gap-2"><span className="text-red-600 font-bold">•</span> <span><strong>Formulaire de contact :</strong> nom, e-mail, téléphone, message</span></li>
                <li className="flex gap-2"><span className="text-red-600 font-bold">•</span> <span><strong>Demande de devis :</strong> nom, e-mail, téléphone, type d&apos;appareil, description de la panne</span></li>
                <li className="flex gap-2"><span className="text-red-600 font-bold">•</span> <span><strong>Prise de rendez-vous :</strong> nom, e-mail, téléphone, créneau souhaité, appareil concerné</span></li>
                <li className="flex gap-2"><span className="text-red-600 font-bold">•</span> <span><strong>Click &amp; Collect :</strong> nom, e-mail, téléphone, appareil déposé, suivi de réparation</span></li>
              </ul>
            </div>

            <div data-testid="confidentialite-finalites">
              <h2 className="text-base md:text-lg font-bold text-slate-900 flex items-center gap-2 mb-3">
                <UserCheck className="h-5 w-5 text-red-600" />
                2. Finalités du traitement
              </h2>
              <p className="text-sm text-slate-700 leading-relaxed">
                Vos données sont utilisées exclusivement pour : répondre à vos demandes de contact
                et de devis, gérer vos rendez-vous et le suivi de vos réparations, vous envoyer les
                notifications liées à votre dossier (confirmation, appareil prêt). Elles ne sont
                <strong> jamais vendues ni cédées à des tiers</strong> à des fins commerciales.
              </p>
            </div>

            <div data-testid="confidentialite-conservation">
              <h2 className="text-base md:text-lg font-bold text-slate-900 flex items-center gap-2 mb-3">
                <Clock className="h-5 w-5 text-red-600" />
                3. Durée de conservation
              </h2>
              <p className="text-sm text-slate-700 leading-relaxed">
                Les données liées aux demandes de contact et devis sont conservées 3 ans maximum
                après le dernier échange. Les données liées aux réparations (suivi, garantie) sont
                conservées pendant la durée de la garantie légale, soit 2 ans après l&apos;intervention.
              </p>
            </div>

            <div data-testid="confidentialite-cookies">
              <h2 className="text-base md:text-lg font-bold text-slate-900 flex items-center gap-2 mb-3">
                <Cookie className="h-5 w-5 text-red-600" />
                4. Cookies
              </h2>
              <p className="text-sm text-slate-700 leading-relaxed">
                Ce site n&apos;utilise pas de cookies publicitaires ni de traçage à des fins marketing.
                Seuls des cookies techniques strictement nécessaires au fonctionnement du site
                peuvent être déposés (session sécurisée de l&apos;espace d&apos;administration). Les contenus
                embarqués de tiers (TikTok, Facebook, Google Maps) peuvent déposer leurs propres
                cookies, soumis aux politiques de confidentialité de ces plateformes.
              </p>
            </div>

            <div data-testid="confidentialite-droits">
              <h2 className="text-base md:text-lg font-bold text-slate-900 flex items-center gap-2 mb-3">
                <ShieldCheck className="h-5 w-5 text-red-600" />
                5. Vos droits
              </h2>
              <p className="text-sm text-slate-700 leading-relaxed">
                Conformément au RGPD, vous disposez d&apos;un droit d&apos;accès, de rectification,
                d&apos;effacement, de limitation et d&apos;opposition au traitement de vos données. Vous
                pouvez exercer ces droits à tout moment en nous contactant. Vous disposez également
                du droit d&apos;introduire une réclamation auprès de la CNIL (www.cnil.fr).
              </p>
            </div>

            <div data-testid="confidentialite-contact">
              <h2 className="text-base md:text-lg font-bold text-slate-900 flex items-center gap-2 mb-3">
                <Mail className="h-5 w-5 text-red-600" />
                6. Contact
              </h2>
              <p className="text-sm text-slate-700 leading-relaxed">
                Pour toute question relative à vos données personnelles :{" "}
                <a href="mailto:imediastore79@gmail.com" className="text-red-600 hover:underline">imediastore79@gmail.com</a>{" "}
                ou par courrier : Mediastore, 104 Rue de la Gare, 79000 Niort.
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}
